import { toUpper } from 'lodash';

export const isValidPromotionCode = (code: string): boolean => {
  const regexp = new RegExp(/^.[a-zA-Z0-9]+$/);

  return Boolean(code) && code.length >= 8 && code.length <= 12 && regexp.test(code);
};

export const fetchPromotionCodeFromURL = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get('promotion_code');
};

export const storePromoCodeFromURL = () => {
  const code = fetchPromotionCodeFromURL();

  if (code && isValidPromotionCode(code)) {
    localStorage.setItem('promotionCode', toUpper(code));
  }
};

export const getPromoCodeFromStore = (isAuthorized: boolean) => {

  const codeFromURL = fetchPromotionCodeFromURL();

  if (!isAuthorized && codeFromURL) {
    return codeFromURL;
  }

  return localStorage.getItem('promotionCode');
};
